import React, { useState } from 'react';

type DesignNameInputProps = {
  value?: string;
  onChange: (value: string) => void;
  maxLength?: number;
};

const DesignNameInput: React.FC<DesignNameInputProps> = ({ 
  value = '', 
  onChange, 
  maxLength = 128 
}) => {
  const [inputValue, setInputValue] = useState<string>(value);

  const isValidInput = (input: string): boolean => {
    const validPattern = /^[a-zA-Z0-9\s\-_]*$/;
    return validPattern.test(input);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    if (isValidInput(newValue) || newValue === '') {
      setInputValue(newValue);
      onChange(newValue);
    }
  };

  const remainingChars = maxLength - inputValue.length;

  return (
    <div className="w-full">
      <label className="block uppercase font-bold mb-2.5">Design Name</label>
      <input
        type="text"
        placeholder="Enter design name"
        id="design-name"
        name="design-name"
        maxLength={maxLength}
        value={inputValue}
        onChange={handleInputChange}
        className="p-2.5 w-full border-b-2 rounded outline-none"
        style={{ border: '1px solid rgb(204, 204, 204)' }}
      />
      <div className="flex justify-between items-center mt-1">
        <span className="text-xs italic text-gray-400">
          Up to {maxLength} characters
        </span>
        <span className="text-xs text-gray-400">
          {remainingChars} remaining
        </span>
      </div>
    </div>
  );
};

export default DesignNameInput;